module.exports = __webpack_public_path__ + "static/media/LabourTeq_Logo_NavBar.16681d14.svg";